exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (min-width:992px){:host .row.vdivide section:not(:last-child):after{background:#e0e0e0;content:\"\";width:1px;display:block;position:absolute;top:10px;bottom:0;right:0;min-height:100px}}:host a{color:#767676;text-decoration:underline;font-size:14px;font-style:italic}:host .explication.explication_why{background-color:transparent;border-radius:2px;border:1px solid #9b9b9b;margin:2rem 0}:host .explication.explication_why p{margin-top:1rem}:host .input-group-addon{margin-left:.2rem}:host .input-group-addon:focus{outline-offset:.1rem;outline:2px solid #2087c8;box-shadow:none;border-radius:2px}:host .focus-outline{margin-bottom:0}:host h2{font-size:1.5rem}:host .input-group-addon-btn{background-color:unset;border:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/account/authentication/authentication.component.scss
// module id = 655
// module chunks = 0